export default __webpack_public_path__ + "static/media/linkedin-lightBlue.cc8f272c.svg";